import React, { FC } from 'react'

import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Title = styled.h2`
  color: ${({ theme }) => theme.common.primaryText};
  font-family: 'Segoe UI';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
`

const Text = styled.p`
  color: ${({ theme }) => theme.common.primaryText};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
`

export const SpotifyGenresModalHeader: FC = () => (
  <Header>
    <Title>Track genres</Title>
    <Text>
      Choose 3-5 relevant genres for the best match. The number in brackets
      shows available curators — more curators mean better chances for your
      track.
    </Text>
  </Header>
)
